<template>
  <div class="data-assistant-page-cont data-assistant-detail">
    <span class="model-title">详细数据</span>
        
    <div v-if="$store.state.userInfo.leadsStatus==7" v-loading="loading">
      <el-table
        v-if="tableData&&tableData.length!=0"
        :data="tableData"
        style="width: 100%"
        height="445"
        ref="multipleTable">
        <el-table-column
          prop="compName"
          label="来访用户"
          width="width">
           <template slot-scope="scope">
              <div v-if="$store.state.userInfo.isMember ==1&& !scope.row.compName.includes('匿名')" style="cursor:pointer;color:#066EB7" @click="goCompany(scope.row.accessCompId,scope.row.clickStr)">{{ scope.row.compName }}</div>
              <div v-if="$store.state.userInfo.isMember ==1&& scope.row.compName.includes('匿名')" >{{ scope.row.compName }}</div>
              <div v-if='$store.state.userInfo.isMember !=1' style="cursor:pointer;color:#066EB7" @click="dialogVisible=true">升级会员享用此服务</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="typeStr"
          label="访问来源"
          width="width">
        </el-table-column>
        <el-table-column
          prop="region"
          label="地域"
          width="width">
          <template slot-scope="scope">
          
            <div v-if="scope.row.country !== '其他' && scope.row.region !==scope.row.city">{{scope.row.country}} {{ scope.row.region }} {{scope.row.city}}</div>
            <div v-if="scope.row.country !== '其他' && scope.row.region === scope.row.city">{{scope.row.country}} {{ scope.row.region }}</div>
            <div v-if="scope.row.country==='其他' && scope.row.region==='其他' && scope.row.city==='其他'"> {{scope.row.country}} </div>
            <!-- 国家省份城市为'' -->
            <div v-if="!scope.row.country && !scope.row.region && !scope.row.city"> 其他 </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="accessTime"
          label="时间"
          width="110">
          <template slot-scope="scope">
              <div>{{ scope.row.accessTime | format('YYYY-MM-DD')  }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="col-chart-content" v-if="!tableData.length && !loading">
          <div class="col-chart-content-img">
              <img style="width:333px;height:97px" src="@/assets/image/common/noData.png" alt>
          </div>
          <p style="font-size:14px;color:#98a3b7;margin-top:10px;font-family: SourceHanSansCN-Regular;">暂无数据...</p>
      </div>
      <div  style="text-align: center; margin-top: 26px; margin-bottom:31px"  v-if=" tableData&&tableData.length!=0">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          @size-change="sizeChange"
          @current-change="currentChange"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="curPage"
          :page-size="pageSize"
        >
        </el-pagination>
      </div>
      
    </div>
    <div class="col-chart-content" v-else>
      <div class="col-chart-content-img">
          <img src="@/assets/image/common/dataAssistant.png" alt>
      </div>
      <div class="col-chart-content-intro">升级会员享有此服务</div>
    </div>

    <el-dialog
      custom-class="dialogClass"
      :visible.sync="dialogVisible"
      width="390px"
      :before-close="handleClose">
      <div>
        <p class='msg-one'>
          <i class="iconfont icon-icon-xinxijingshi"></i>
          <span>升级会员享有此服务</span>
        </p>
        <p class='msg-two'>如需帮助，请联系您的客服经理</p>
        <div class='msg-three'>
          <div>
            <p>{{$store.state.salesInfoData.userName}}</p>
            <p>客服经理</p>
          </div>
          <p class="msg-message">
            <i class="iconfont icon-icon-shoujihao"></i>
            <span>{{$store.state.salesInfoData.phone}}</span>
          </p>
          <p class="msg-message">
            <i class="iconfont icon-icon-zuojihao"></i>
            <span>{{$store.state.salesInfoData.tel}}</span>
          </p>
          <p class="msg-message">
            <i class="iconfont icon-icon-zuojihaobeifen"></i>
            <span style="color:#066EB7">{{$store.state.salesInfoData.email}}</span>
          </p>
        </div>
      </div>
    </el-dialog>
    
  </div>  
</template>

<script>
import { getDataDetail } from "@/utils/api/dashboard";
import { onlineUrl } from '@/utils/config';

export default {
  props:{
    startTime:{
      typeof: String,
      default: ''
    },
    endTime:{
      typeof: String,
      default: ''
    }
  },
  data() {
    return {
      tableData: [],
      totalNum:0,
      curPage:1,
      pageSize:10,
      loading: false,
      dialogVisible: false,
    }
  },
  watch: {
    startTime: {
      handler(newVal) {
        if(newVal && this.$store.state.userInfo.leadsStatus==7) {
          this.curPage=1
          this.getDataList()
        }
      },
    }
  },
  methods: {
    handleClose(){
      this.dialogVisible = false
    },
    // 跳转公司
    goCompany(id,tag){
      if(id && !tag){
        window.open( `${ onlineUrl }/comp/supplier/view-encrypt-buyer-profile/${id}`,'_blank');
      }else{
        this.dialogVisible = true
      }
    },
    // 每页条数改变时
    sizeChange(size) {
      this.pageSize = size
      this.curPage = 1
      this.getDataList()
      const multipleTable = this.$refs.multipleTable;
      if (multipleTable)  multipleTable.bodyWrapper.scrollTop = 0;
    },

    // 页数改变时
    currentChange(cur) {
      this.curPage = cur
      this.getDataList()
      const multipleTable = this.$refs.multipleTable;
      if (multipleTable)  multipleTable.bodyWrapper.scrollTop = 0;
    },

    //获取详细列表数据
    getDataList() {
      this.loading = true;
      const params = {
        pageSize: this.pageSize,
        curPage: this.curPage,
        startDate: this.startTime,
        endDate: this.endTime,
      }
      getDataDetail(params)
        .then(res => {
          if(res.rspResult.bizCode == 200) {
            this.tableData = res.rspPageData.list || [];  
            this.totalNum= res.rspPageData.totalNum || 0;
          }
          this.loading = false;
        })
        .catch(err=> {
          this.loading = false;
          console.error('获取详细数据列表失败', err)
        })
    },
  },

  mounted() {
    if(this.$store.state.userInfo.leadsStatus==7){
      this.getDataList()
    }

  }
}
</script>

<style lang="scss" scoped>
.data-assistant-detail {
  background: #fff;
  padding: 20px 20px 20px 20px;
  .myrfq-cont {
    display: flex;
    flex-wrap: wrap;
    .myrfq-item {
      // width: 183px;
      width: calc((100% - 64px) / 4);
      // max-width: 220px;
      height: 82px;
      border-radius: 4px;
      margin-right: 16px;
      margin-bottom: 16px;
      &-link {
        height: 100%;
        box-sizing: border-box;
        display: block;
        padding: 14px 16px;
        background: #F5F7FA;
        &:hover {
          background: #F1F7FA;
        }
      }
      &-icon {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        text-align: center;
        color: #fff;
        margin-bottom: 8px;
        .iconfont {
          line-height: 24px;
          font-size: 12px;
          display: inline-block;
          &.icon-icon-kanban5 {
            margin-left: -1px;
          }
        }

      }
      &-b {
        display: flex;
        align-items: center;
        user-select: none;
        .myrfq-item-label {
          width: max-content;
          margin-right: 10px;
          flex-shrink: 0;
          height: 14px;
          line-height: 14px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #16181A;
          letter-spacing: 0;
          text-align: justify;
        }
        .myrfq-item-value {
          flex: 1;
          height: 22px;
          font-family: Arial;
          font-weight: Bold;
          font-size: 20px;
          line-height: 22px;
          color: #318CED;
          letter-spacing: 0;
          text-align: right;
        }
      }
      &:nth-last-child(1) {
        margin-right: 0;
      }

      // 处理图标的背景和数量的颜色
      .icon-bg-1 {
        background-image: linear-gradient(155deg, #FF9046 0%, #FF6600 100%);
      }
      .item-value-1 {
        color: #FF7F2A;
      }
      .icon-bg-2 {
        background-image: linear-gradient(155deg, #8992FC 0%, #4956F1 100%);
      }
      .item-value-2 {
        color: #318CED;
      }
      .icon-bg-3 {
        background-image: linear-gradient(155deg, #D264FF 0%, #9B1DEB 100%);
      }
      .item-value-3 {
        color: #A024ED;
      }
      .icon-bg-4 {
        background-image: linear-gradient(155deg, #FF9046 0%, #FF6600 100%);
      }
      .item-value-4 {
        color: #FF7F2A;
      }
      .icon-bg-5 {
        background-image: linear-gradient(155deg, #5BDC5D 0%, #20B820 100%);
      }
      .item-value-5 {
        color: #20B820;
      }
      .icon-bg-6 {
        background-image: linear-gradient(155deg, #5FC0F7 0%, #318CED 100%);
      }
      .item-value-6 {
        color: #318CED;
      }
      .icon-bg-7 {
        background-image: linear-gradient(155deg, #59E5D3 0%, #48D2BE 100%);
      }
      .item-value-7 {
        color: #4BD5C1;
      }

    }
  }
  .col-chart-content{
    text-align: center;
    &-img{
      margin-top:40px;
        img{
          width: 260px;
          height: 160px;
        }
    }
    &-intro{
      color: #4F5D78;
      font-size: 12px;
      font-family: SourceHanSansCN-Regular;
    }
  }
  
}
::v-deep .dialogClass{
  .el-dialog__body{
    padding: 0 32px 30px;
  }
  .el-dialog__headerbtn{
    top: 31px;
    right: 32px;
  }
  .el-dialog__close{
      font-weight: 600;
  }
  div{
    text-align:center ;
    .msg-one{
      color:#FF6905;
      i{
        font-size: 16px; 
        margin-right: 5px;
      }
      span{
        font-size: 16px;
        font-family: SourceHanSansCN-Medium;
      }
    }
    .msg-two{
      margin:20px 0 20px;
      color: #4F5D78;
      font-family: SourceHanSansCN-Regular;
    }
    .msg-three{
      width: 268px;
      box-shadow: 0 0 6px 0 #066eb71a;
      border-radius: 2px;
      margin:0 auto;
      text-align: left;
      line-height:20px;
      padding:16px;
      background-image:url('~@/assets/image/common/upcard.jpg') ;
      div{
        p{
          text-align: left;
          color: #16181A;
        }
        p:first-child{
          font-weight: 600;
        }
        p:last-child{
          color:#4F5D78;
          font-size:12px;
          line-height: 16px;
          margin-bottom: 17px;
          font-family: SourceHanSansCN-Medium;
        }
      }
      .msg-message{
        line-height: 24px;
        i{
          color: #FF7F2A;
          margin-right:8px;
          font-size: 12px;
        }
        span{
          color: #16181A;
        }
      }

    }
  }
}
</style>